/**
 * Generate a v4 UUID as a string (xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx).
 * @returns {string} - Randomly generated UUID.
 */
export function generateUUID(): string {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0;
    // If 'x', use random; if 'y', guarantee variant is 8,9,a,b
    const v = c === 'x' ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
}
